export default __webpack_public_path__ + "4a7f861c5113171d37e74017d2c14f0a.svg";